import React from 'react'
import { Modal } from '@surecompanies/core_components'
import { ExclamationCircleFilled } from '@ant-design/icons'

interface MarqetaConfirmModalProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function MarqetaConfirmModal({
  open,
  onConfirm,
  onCancel,
}: MarqetaConfirmModalProps) {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <ExclamationCircleFilled style={{ fontSize: 22, color: '#faad14' }} />
          <span>Create Marqeta card?</span>
        </div>
      }
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Continue"
      cancelText="Cancel"
      width={400}
      centered
      destroyOnClose
      getContainer={false}
      maskClosable={true}
    >
      <p
        style={{
          color: '#576983',
          fontSize: 14,
          margin: 0,
          paddingLeft: 34,
        }}
      >
        WEX is the standard provider. Only continue with Marqeta if the carrier
        does not accept WEX.
      </p>
    </Modal>
  )
}
